import React from "react";
import { Collapse, Input, Button } from "antd";
import { Link } from "react-router-dom";
import { SVGicon } from "../../../styleGuide/SVGicon/SVGicon";
import "./FAQ.css";
const { Panel } = Collapse;

const text = `
Metropolis helps organisation looking to hire doctors to easily connect to active candidates from the Metropolis network of 40,000 UK-based doctors. We bridge the gap between expensive locum agencies and DIY solutions like Indeed and LinkedIn that distract your team.
`;

export const FAQ = () => {
  const onChange = (key) => {
    console.log(key);
  };
  return (
    <>

      <section className="FAQ-wrap">
        <div className="mtp-container">
          <div className="FAQ-title-wrap flex-center">
            <h3 className="fw-700 text-color-alpha" >Frequently Asked Questions</h3>
            <span className="fw-400 text-color-bravo" >Have questions? We are here to help.</span>
          </div>
          <div className="mtp-accordion">
            <div className="search-input-wrap flex-center">
              <Input className="faq-search-input" placeholder="Search" />
              <div className="faq-search-icon flex-center flex-center-auto-0">
                <Button className="flex-center" icon={SVGicon.mtpIconSearch} />
              </div>
            </div>
            <div className="mtp-accordion-wrapper">
              <Collapse
                accordion
                defaultActiveKey={["1"]}
                onChange={onChange}
                expandIcon={({ isActive }) =>
                  isActive ? (
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.70944 9.17506C2.60063 9.17372 2.49262 9.19392 2.39165 9.2345C2.2902 9.27526 2.19787 9.33579 2.12001 9.41255C2.04216 9.4893 1.98034 9.58077 1.93814 9.68163C1.89595 9.78249 1.87422 9.89073 1.87422 10.0001C1.87422 10.1094 1.89595 10.2176 1.93814 10.3185C1.98034 10.4194 2.04216 10.5108 2.12001 10.5876C2.19787 10.6643 2.2902 10.7249 2.39165 10.7656C2.49262 10.8062 2.60063 10.8264 2.70943 10.8251H17.2901C17.3989 10.8264 17.507 10.8062 17.6079 10.7656C17.7094 10.7249 17.8017 10.6643 17.8796 10.5876C17.9574 10.5108 18.0192 10.4194 18.0614 10.3185C18.1036 10.2176 18.1254 10.1094 18.1254 10.0001C18.1254 9.89073 18.1036 9.78249 18.0614 9.68163C18.0192 9.58077 17.9574 9.4893 17.8796 9.41255C17.8017 9.33579 17.7094 9.27526 17.6079 9.2345C17.5069 9.19392 17.3989 9.17372 17.2901 9.17506H2.70944Z" fill="currentColor" stroke="black" strokeWidth="0.4" /></svg>)
                    : (
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.4077 2.12468C9.25579 2.28121 9.17206 2.49152 9.17479 2.70959V9.17491H2.70943C2.60063 9.17357 2.49262 9.19377 2.39165 9.23435L2.46622 9.41993L2.39165 9.23435C2.2902 9.27512 2.19787 9.33564 2.12001 9.4124C2.04216 9.48916 1.98034 9.58062 1.93814 9.68148C1.89595 9.78234 1.87422 9.89058 1.87422 9.99991C1.87422 10.1092 1.89595 10.2175 1.93814 10.3183C1.98034 10.4192 2.04216 10.5107 2.12001 10.5874C2.19787 10.6642 2.2902 10.7247 2.39165 10.7655C2.49262 10.8061 2.60063 10.8263 2.70943 10.8249H9.17479V17.2903C9.17345 17.3991 9.19365 17.5071 9.23422 17.6081L9.4198 17.5335L9.23422 17.6081C9.27499 17.7095 9.33551 17.8018 9.41227 17.8797C9.48903 17.9575 9.5805 18.0194 9.68136 18.0616C9.78222 18.1038 9.89046 18.1255 9.99979 18.1255C10.1091 18.1255 10.2174 18.1038 10.3182 18.0616C10.4191 18.0194 10.5105 17.9575 10.5873 17.8797C10.6641 17.8018 10.7246 17.7095 10.7654 17.6081C10.8059 17.5071 10.8261 17.3991 10.8248 17.2903V10.8249H17.2901C17.3989 10.8263 17.5069 10.8061 17.6079 10.7655C17.7094 10.7247 17.8017 10.6642 17.8796 10.5874C17.9574 10.5107 18.0192 10.4192 18.0614 10.3183C18.1036 10.2175 18.1254 10.1092 18.1254 9.99991C18.1254 9.89058 18.1036 9.78234 18.0614 9.68148C18.0192 9.58062 17.9574 9.48915 17.8796 9.4124C17.8017 9.33564 17.7094 9.27512 17.6079 9.23435L17.5334 9.41993L17.6079 9.23435C17.507 9.19377 17.3989 9.17357 17.2901 9.17491H10.8248V2.70962C10.8262 2.59971 10.8056 2.49062 10.7642 2.38877L10.5789 2.46404L10.7642 2.38877C10.7226 2.28646 10.661 2.19354 10.5828 2.1155L10.5828 2.1155C10.5047 2.03746 10.4117 1.97591 10.3093 1.93448C10.207 1.89305 10.0973 1.87259 9.9869 1.87432C9.76829 1.87773 9.55997 1.96778 9.4077 2.12468Z" fill="currentColor" stroke="#393E40" strokeWidth="0.4" />
                      </svg>
                    )
                }
              >
                <Panel header="What is Metropolis?" key="1" arrow="right">
                  <p>{text}</p>
                </Panel>
                <Panel header="How does it work?" key="2">
                  <p>{text}</p>
                </Panel>
                <Panel header="Who is Metropolis for?" key="3">
                  <p>{text}</p>
                </Panel>
                <Panel header="What kinds of doctors are on Metropolis?" key="4">
                  <p>{text}</p>
                </Panel>
                <Panel header="What is the vetting process for doctors?" key="5">
                  <p>{text}</p>
                </Panel>
                <Panel header="How much does it cost?" key="6">
                  <p>{text}</p>
                </Panel>
                <Panel header="How long have Metropolis been around?" key="7">
                  <p>{text}</p>
                </Panel>
              </Collapse>
            </div>
          </div>
        </div>
      </section>
      <section className="get-In-Touch ground-color-ashes">
        <div className="mtp-container">
          <div className="question-wrap flex-center">
            <h4 className="fw-700 text-color-alpha">Still have Questions?</h4>
            <span className="fw-400 text-color-bravo">Can’t find the answer you’re looking for? Please contact to our friendly team.</span>
            <Link className="get-in-touch-link " to="/contact">Get In Touch</Link>
          </div>
        </div>
      </section>


    </>
  );
};
